import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import {
	requestOAuthLink,
	STRIPE_OAUTH_LINK_REQUEST, STRIPE_OAUTH_LINK_SUCCESS, STRIPE_OAUTH_LINK_FAILURE
} from './actions';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';

class AuthorizationRefreshCallback extends Component {
	componentDidMount() {
		const { queryParams: { paymentConfigurationId, returnPath }, requestOAuthLink, location } = this.props;
		if (paymentConfigurationId) {
			requestOAuthLink({ paymentConfigurationId, returnPath, refreshPath: `${location.pathname}${location.search}` });
		}
	}

	render() {
		const { queryParams: { returnPath }, t } = this.props;

		return <ReduxBlockUi block={STRIPE_OAUTH_LINK_REQUEST} unblock={[STRIPE_OAUTH_LINK_FAILURE]} renderChildren={false}>
			<Link to={returnPath} className='btn btn-default'>{t('Common_Back')}</Link>
		</ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const queryParams = queryString.parse(ownProps.location.search);

	return {
		queryParams
	};
};

export default connect(mapStateToProps, {
	requestOAuthLink
})(withTranslation()(AuthorizationRefreshCallback));